// CSR Context definition
import { createContext } from 'react';

export interface CSRContextUser {
  id: string;
  email: string;
  full_name: string;
  company_id: string;
  company_name: string;
}

export interface CSRContextType {
  isCSR: boolean;
  isActingAsUser: boolean;
  targetUser: CSRContextUser | null;
  availableUsers: CSRContextUser[];
  switchToUser: (user: CSRContextUser | null) => void;
  clearContext: () => void;
  loading: boolean;
}

export const CSRContext = createContext<CSRContextType>({
  isCSR: false,
  isActingAsUser: false,
  targetUser: null,
  availableUsers: [],
  switchToUser: () => {},
  clearContext: () => {},
  loading: true
});